import CustomerSignUpBank from '../../../auth/customer/signupBank';

const CustomerEditBank = () => {
  return <CustomerSignUpBank isChangeCredit={true} />;
};

export default CustomerEditBank;
